import { observable }             from 'mobx'

import { API
       , kde_api_client_t }         from '../02_api'
import { CRUD
       , FACTORY
       , Filter
       }                          from '../09_model_app'


let g_clients: MClients ;

export const filter_by_client_name = (opts: kde_api_client_t, txt: string ) =>
{
  const re = new RegExp( txt || '', "i" ) ;

  return re.test( opts.name ) || re.test( opts.surnames ) ;
} ;

export class MClients
{
  @observable public selected_client: number | null = null ;

  public filter_name    = Filter( 'name', filter_by_client_name ) ;
  public filter_contact = Filter<string>( 'contact', (opts: kde_api_client_t, value ) =>
                                {
                                  const contact = opts.contact ;

                                  if ( !value || !value.trim( ).length )
                                       return true ;

                                  if ( !contact )
                                       return false ;

                                  const re = new RegExp( value, "i" ) ;

                                  return ( !!contact.email && re.test( contact.email ) )
                                      || ( !!contact.phone && re.test( contact.phone ) )
                                      || ( !!contact.fax   && re.test( contact.fax   ) ) ;
                                } ) ;
  public filter_addr    = Filter<string>( 'address', (opts: kde_api_client_t, value) =>
                                {
                                  const address = opts.address ;

                                  if ( !value || !value.trim( ).length )
                                       return true ;

                                  if ( !address )
                                       return false ;

                                  const re = new RegExp( value, "i" ) ;

                                  return ( !!address.street1  && re.test( address.street1  ) )
                                      || ( !!address.street2  && re.test( address.street2  ) )
                                      || ( !!address.zipCode  && re.test( address.zipCode  ) )
                                      || ( !!address.city     && re.test( address.city     ) )
                                      || ( !!address.country  && re.test( address.country  ) )
                                      || ( !!address.province && re.test( address.province ) ) ;
                                } ) ;

  clients = new CRUD<kde_api_client_t>(
      user => API.CLIENTS( user? user.workgroup!.cloud.id : 0 )
    , user => 
       FACTORY.CLIENTS.data_fetcher_for( { cloud_id: user? user.workgroup!.cloud.id : 0 } )
    , data =>
       data.filter( row => this.filter_name.pass_filter( row ) 
                        && this.filter_addr.pass_filter( row ) 
                        && this.filter_contact.pass_filter( row ) )
    ) ;


  public static instance ( )
  {
    if ( !g_clients )
          g_clients = new MClients( ) ;

    return g_clients ;
  }
}

